import { TlfContextProps, TlfVariantPatchSelectionVersion } from "./interface";

/**
 * Updates the active patch composition and its snapshot for the current TLF history version.
 *
 * @param state - Current TLF context state
 * @param appliedPatchNames - Patch names composing the current TLF
 * @param activePatchName - Patch that should receive subsequent edits
 * @returns State with the current selection recorded in history
 */
export const updateVariantPatchSelection = (
  state: TlfContextProps,
  appliedPatchNames: string[],
  activePatchName: string | null,
): TlfContextProps => {
  const appliedVariantPatches = [...appliedPatchNames];
  const nextActivePatchName = appliedPatchNames.length === 0 ? null : activePatchName;
  const currentSelection: TlfVariantPatchSelectionVersion = {
    appliedVariantPatches,
    activeVariantPatchName: nextActivePatchName,
  };
  const variantPatchSelectionVersions = state.tlfDataVersions.map((_, index) =>
    index === state.ixTlfDataVersion
      ? currentSelection
      : (state.variantPatchSelectionVersions[index] ?? {
          appliedVariantPatches: [],
          activeVariantPatchName: null,
        }),
  );

  return {
    ...state,
    appliedVariantPatches,
    activeVariantPatchName: nextActivePatchName,
    variantPatchSelectionVersions,
  };
};
